import styled from 'styled-components';

export default styled.div`
	display: flex;
	align-items: center;
	gap: var(--px-10);

	.info-link-icon {
		display: flex;
		align-items: center;
	}
`;
